/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Reason_Invoice_Draft_StuckInputs */



/**
* | output |
* | --- |
* | "Invoice draft stuck · creation could not be confirmed" |
*
* @param {Partner_Billing_Board_Reason_Invoice_Draft_StuckInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_reason_invoice_draft_stuck = /** @type {((inputs?: Partner_Billing_Board_Reason_Invoice_Draft_StuckInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Reason_Invoice_Draft_StuckInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnungsentwurf hängt · Erstellung nicht bestätigt")
	return /** @type {LocalizedString} */ ("Invoice draft stuck · creation could not be confirmed")
});